<div class="container-fluid glb-popup" style="width: 550px">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">title</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12 mb-3">
          <span class="p-float-label w-100">
            <p-calendar formControlName="dateToFollowup" inputId="dateToFollowup"
              dateFormat="yy-mm-dd" [showIcon]="true" appendTo="body"
              inputStyleClass="p-inputtext w-100">
            </p-calendar>
            <label for="dateToFollowup">Follow-up date</label>
          </span>
        </div>

        <div class="col-lg-12 mb-3"><span>Assigned To</span> <app-user-search (onUserSelected)="onAssignedToUserSeleted($event)"  [selectedUser]="assignedToUser" [showCreateUser]="false"></app-user-search>
      </div>
      <div class="col-lg-12 ">
        <span>Team</span><app-team-search (onTeamSelected)="onAssignedToTeamSeleted($event)"  [selectedTeam]="assignedToTeam" [showCreateTeam]="false"></app-team-search>
      </div>


    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!taskId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
            }

          </div>
        </div>
      </div>
    </div>
  </div>
